import React, { useState, useEffect, useContext } from "react";
import { getTroubleshooterQuery, getTroubleshooterCntQuery, setExecuteTroubleShooter, deletePendingJob, getPendingJobStatus } from "../../graphql/troubleshoot_queries";
import { getJsonSchemaQuery } from "../../graphql/configuration_queries";
import { useQuery, useApolloClient } from "@apollo/client";
import { GlobalContext } from "../../hooks/globalContext";
import { Link } from "react-router-dom";
import AppConfig from "../../utility/AppConfig";
import apiCall from "../../utility/api";


type dataProps = {
    data: any;
    func: any;
    searchVal: any;
    pageNo: any;
    setTotalPages: any;
    setTotalRecords: any;
    executeBtnClicked: any;
    setExecuteBtnClicked: any;
    selectedAuto: any;
    setmessagebar: any;
    setmessage: any;
    isRefresh?: any,
    setIsRefresh?: any
    setRefreshToast?: any
    setSubAutomationDetails: any
    setJsonData: any
    setUiData: any
    setExportDetails: any
    exportBtnClicked?: any
    setExportBtnClicked?: any
    isFilter?: any
    dropDownValue1?: any
    setIsFilter?: any
    dropDownValue2?: any
    filterArray?: any
    setPendingJob?: any
    pendingJob?: any
    rowDesc?: any
    setRowDesc?: any
    setPreviousJob?: any
    previousJob?: any
    setCategoryData?: any
    pageName?: string
    setTroubleshootErrorMsg?: any
    setPending?: any
    pending?: any
    setEmptyPendingJob?: any
    emptyPendingJob?: any
    setToastIntent?: any
    overlayopen?: any
    setOverlayOpen?: any
    selectedArray?: any,
    pushClassificationType?: any
    setPushClassificationType?: any
    pushClassification?: any
    setPushClassification?: any
    setIsAutomationLoading?: any
}

export const Troubleshooter_func = (props: dataProps) => {
    const client = useApolloClient();
    const contextValue: any = useContext(GlobalContext);
    const tenantName = contextValue.tenantName;
    const selectedIDs = contextValue.selectedRowIdInTable;
    const email =contextValue.userSessionDetails.otherDetails.emailid;
    //console.log("executeBtnClicked----------", props.executeBtnClicked);

    let profile = props.selectedAuto.name;
    profile = profile.toString();
    const profileName = profile.replace(/\s/g, '');
    var automationDesc = props.selectedAuto.desc;

    const getshooterList = async (whereCondition: any, limit: any, offset: any, listType: String = '') => {
        try {
            let data = await apiCall('/troubleshoot/getTroubleshootList', { ...whereCondition, limit, offset });
            // props.setExportDetails && props.setExportDetails(data?.data);
            if (data?.status == 'success') {
                if (listType === 'subAutomation') {
                    data.data.map(async (data: any) => {
                        console.log('data.dartid = ' + data.dartid);
                        await getJsonSchema(data.dartid);
                    })
                    props.setSubAutomationDetails(data.data);
                    props.setIsAutomationLoading(false);
                } else {
                    console.log("here in else")
                    props.func(data.data);
                }
            }
        } catch (error) {
            console.log('getTroubleshootList error= ', error);
        }
    }

    const exportshooterList = async (whereCondition: any) => {
        try {
            let data = await apiCall('/troubleshoot/getTroubleshootList', { ...whereCondition });
            if (data?.status == 'success') {
                props.setExportDetails && props.setExportDetails(data?.data);
            }
        } catch (error) {
            console.log('getTroubleshootList error= ', error);
        }
    }

    const getJsonSchema = async (dartid: number) => {
        try {
            const { data, status } = await apiCall('/automation/getSchema', { dartid: dartid });

            if (status === 'success' && data.length > 0) {
                let uiSchema = JSON.parse(data[0]?.uiSchema);
                let jsonSchemaData = JSON.parse(data[0]?.jsonSchema);

                uiSchema["ui:submitButtonOptions"] = { "norender": true };
                console.log('data[0]?.jsonSchema = ' + data[0]?.jsonSchema)
                console.log('data[0]?.uiSchema = ' + data[0]?.uiSchema)
                data[0]?.jsonSchema != undefined && props.setJsonData(jsonSchemaData);
                data[0]?.uiSchema != undefined && props.setUiData(uiSchema);
            } else {
                props.setJsonData({});
                props.setUiData({});
            }
        } catch (error) {
            console.log("getJsonSchema error=", error);
            props.setJsonData({});
            props.setUiData({});
        }
    };

    const getTroubleshooterCnt = async (whereCondition: any) => {
        try {
            let { status, data } = await apiCall('/troubleshoot/getTroubleshootListCount', { ...whereCondition });
            if (status == 'success') {
                console.log('here coming', data?.totalRecords)
                props.setTotalRecords(data?.totalRecords);
                props.setTotalPages(data?.totalPages);
            }
        } catch (error) {
            console.log('getTroubleshooterCnt error =', error)
        }
    }

    // const getTroubleshooterCnt = async (whereCondition: any) => {
    //     const { data, loading, error } = await client.query({
    //         query: getTroubleshooterCntQuery,
    //         variables: { whereCondition },
    //         fetchPolicy: 'network-only'
    //     });

    //     if (!loading && data) {
    //         props.setExportDetails && props.setExportDetails(data.core_AutomationJSON);
    //         props.setTotalRecords(data.core_AutomationJSON?.length);
    //         props.setTotalPages(Math.ceil((data.core_AutomationJSON?.length) / 50));
    //     }
    // };

    const troubleshooterPush = async (serviceTag: string, solutionVar: string, deviceStatus: string, applicationname:string, pushClassification: string, pushClassificationType: string) => {
        // var url = `${AppConfig.DASHBOARD_V2_API_URL}/pushSolutionItems`;
        console.log("pushclassification",pushClassification)
        var url = `/troubleshoot/pushSolutionItems`;
        var postData = {
            "servicetag": serviceTag,
            "solutionVar": solutionVar,
            "username": email,
            "pushClassification" : pushClassification ? pushClassification : '',
            "pushClassificationType" : pushClassificationType ? pushClassificationType : '',
            "type": 'Interactive',
            "applicationname": applicationname
        };
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        try {
            props.setOverlayOpen(false); 
            let { status, msg } = await apiCall(url, postData, "POST");
            props.selectedArray([]);
            if (status == "success") {
                if (deviceStatus == "online") {
                    const troubleshootingLink = <Link to="/manage/troubleshoot/status">Troubleshooting Status</Link>;
                    props.setmessage(
                        <>Troubleshooter Executed Successfully. Please check {troubleshootingLink} for detailed information on the execution status.</>
                    );
                } else if (deviceStatus == "offline") {
                    props.setmessage("Troubleshooter Pushed Successfully");
                }
                props.setmessagebar(true);
                props.setExecuteBtnClicked(false);
            } else {
                props.setmessage("Troubleshooter Pushed Failed!");
                props.setTroubleshootErrorMsg(true)
                props.setToastIntent('error')
                props.setExecuteBtnClicked(false);
            }
        } catch (error) {
            props.setOverlayOpen(false); 
            props.setTroubleshootErrorMsg(true)
            props.setmessage("Troubleshooter Pushed Failed!");
            props.setToastIntent('error')
            props.selectedArray([]);
            props.setExecuteBtnClicked(false);
            console.error(error)
        }
            // }).catch((error) => console.error(error));
    }

    const troubleshooter_exec = async (userId: any, Dart: any, name: any, NotificationWindow: any, OS: any, ProfileName: any, ProfileOS: any, shortDesc: any, type: any, Jobtype: any, variable: any) => {
        const { data } = await client.mutate({
            mutation: setExecuteTroubleShooter,
            variables: { userId, OS, type, name, Dart, variable, shortDesc, Jobtype, ProfileName, NotificationWindow, ProfileOS },
            fetchPolicy: 'network-only'
        });

        if (data?.AddRemoteJobs?.length > 0) {

            if (data.AddRemoteJobs[0].code === 'ok' && data.AddRemoteJobs[0].onlineOffline === 'Online') {
                const troubleshootingLink = <Link to="/manage/troubleshoot/status">Troubleshooting Status</Link>;
                props.setmessage(
                    <>Troubleshooter Executed Successfully. Please check {troubleshootingLink} for detailed information on the execution status.</>
                );
            } else if (data.AddRemoteJobs[0].code === 'ok' && data.AddRemoteJobs[0].onlineOffline === 'Offline') {
                props.setmessage("Troubleshooter Pushed Successfully");
            }

            props.setmessagebar(true);
            props.setExecuteBtnClicked(false);
        } else {
            props.setmessagebar(true);
            props.setExecuteBtnClicked(false);
        }
    }

    const deletePendingJobs = async () => {
        {
            let applicationname = props.rowDesc;
            let tenant = tenantName;
            try {
                let whereCondition = { applicationname: applicationname, tenant: tenant }
                let { status, data } = await apiCall('/troubleshoot/deletePendingJobs', { ...whereCondition });
                if (data.affected_rows === 0 && status === "success") {
                    props.setPendingJob(false);
                    console.log("Pending Job Cleared");
                    // alert("Pending Job Cleared")
                } else if (data.affected_rows === 0 && status === "failure") {
                    props.setEmptyPendingJob(true);
                    console.log("No Pending Job to clear");
                    // alert("Pending Job Cleared")
                } else {
                    props.setEmptyPendingJob(true);
                    console.log("Pending Job Not Cleared");
                }
            } catch (error) {
                console.error("An error occurred:", error);
            }
        }
    };

    const getPendingjobStatus = async () => {

        let applicationname = props.rowDesc;
        let tenant = tenantName;
        try {
            let whereCondition = { applicationname, tenant }
            let { status, data } = await apiCall('/troubleshoot/getPendingJobStatus', { ...whereCondition });
            console.log('pendingjob data: ' + data)
            console.log('pendingjob status: ' + status)

            if (data?.length > 0) {
                props.setPreviousJob(true);
            } else {
                props.setPreviousJob(false);
                let pushClassificationType = props.pushClassificationType;
                let pushClassification = props.pushClassification
                console.log('pushClassification: ' + pushClassification);
                if (Array.isArray(selectedIDs)) {
                    const selectedIDsLen = selectedIDs.length;
                    let type: any;

                    if (selectedIDsLen != null && selectedIDsLen !== undefined) {
                        type = "ServiceTag";
                        var uniqueSelectedIDs = new Set(selectedIDs);
                        var selectedIDsArr = Array.from(uniqueSelectedIDs);
                        // let pushClassificationType = props.pushClassificationType;
                        // let pushClassification = props.pushClassification
                        //var userId = 235
                        selectedIDsArr.map(async (val: any) => {
                            // await troubleshooter_exec(235, 286, val, 0, "unknown", profile, "common", automationDesc, type, "Interactive", profileName);
                            var hostname = val.split("-/-")[0];
                            var status = val.split("-/-")[1];
                            console.log("val=", val);

                            console.log("hostname=", hostname);
                            console.log("status=", status);
                            console.log("pushClassificationType=", props.pushClassificationType);
                            console.log("pushClassification=", props.pushClassification);                            
                            await troubleshooterPush(hostname, profileName, status, applicationname, pushClassification, pushClassificationType);
                        });
                    } else {
                        console.log("selectedIDsLen is null or undefined.");
                    }
                } else {
                    console.log("selectedIDs is not an array.");
                }
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }

    }


    useEffect(() => {
        let types: string[];
        console.log('props.pageName : ', props.pageName);
        if (props.pageName == 'compliancepolicy') {
            types = ["policy"]
        } else {
            types = ["selfhelp", "proactive"]
        }
        if(props?.searchVal?.length > 0 && props.searchVal !== ''){
            getshooterList({ types: types , tenant: `${tenantName}`, search: props.searchVal, function: 'search'  }, 50, parseInt(props.pageNo));
            getTroubleshooterCnt({ types: types , tenant: `${tenantName}`, search: props.searchVal, function: 'search' });
        }else if(props.isFilter === true){
            getshooterList({ types: types , tenant: `${tenantName}`, filter: props.filterArray, function: 'filter' }, 50, parseInt(props.pageNo));
            getTroubleshooterCnt({ types: types , tenant: `${tenantName}`,filter: props.filterArray, function: 'filter'});
        } else if (props.executeBtnClicked) {
            getPendingjobStatus();
        } else if (props.isRefresh) {
            props.setIsRefresh(false);

            getshooterList({ types: types , tenant: `${tenantName}`  }, 50, parseInt(props.pageNo));
            getTroubleshooterCnt({ types: types , tenant: `${tenantName}`  });
            props.setRefreshToast(true);
            setTimeout(() => {
                props.setRefreshToast(false);
            }, 5000);

        } else if (props.selectedAuto.name.length > 0) {
            console.log('props.selectedAuto: ' ,props.selectedAuto.subAutomation);
            getshooterList({ id: props.selectedAuto.subAutomation?.split(",").map(Number) }, null, null, 'subAutomation');
        } else {
            getshooterList({ types: types , tenant: `${tenantName}` }, 50, parseInt(props.pageNo));
            getTroubleshooterCnt({ types: types , tenant: `${tenantName}` });
        }
    }, [props.searchVal, props.pageNo, props.executeBtnClicked, props.isRefresh, props.selectedAuto, props.isFilter, props.filterArray]);

    useEffect(() => {
        if (props.pendingJob) {
            deletePendingJobs();
            props.setPendingJob(false);
        }
    }, [props.pendingJob])

    useEffect(() => {
        if (props.exportBtnClicked) {
            let types: string[];
            console.log('props.pageName : ', props.pageName);
            if (props.pageName == 'compliancepolicy') {
                types = ["policy"]
            } else {
                types = ["selfhelp", "proactive"]
            }
            exportshooterList({ types: types , tenant: `${tenantName}`, function: 'export' });
            
            props.setExportBtnClicked(false);
        }
    }, [props.exportBtnClicked])


    return (
        <></>
    )
}